import { defineComponent, onMounted, onUnmounted } from 'vue';
import UnlinkOrganisationWarningModalCode
	from '@/presentation/components/organisation-linking/unlink-organisation-warning-modal/unlink-organisation-warning-modal.code';

export default defineComponent({
	setup: () => {
		const code = new UnlinkOrganisationWarningModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			proceedButton: code.proceedButton,
			isSaveEnabled: code.isSaveEnabled,
			entitiesAffectedByUnlinking: code.entitiesAffectedByUnlinking,
			closeModal: code.closeModal.bind(code),
			proceed: code.proceed.bind(code),
		};
	}
});
